(window.PDSlider = function ($, Behaviors) {

  "use strict";
  
  function PDSlider(elem) {
    Behaviors.init(PDSlider, this, arguments)

    this.mainSlider = this.$elem[0].querySelector('#pdp__images .pdp__images-main');
    this.thumbSlider = this.$elem[0].querySelector('#pdp__images .pdp__images-thumbs');

    this.mainSlider2 = this.$elem[0].querySelector('#pdp__images-model2 .pdp__images-main');
    this.thumbSlider2 = this.$elem[0].querySelector('#pdp__images-model2 .pdp__images-thumbs');

    const thumbSlider = new Swiper(this.thumbSlider, {
      wrapperClass: 'pdp__images-thumbs-track',
      slideClass: 'pdp__image-thumb',
      centeredSlides: false,
      //centeredSlidesBounds: true,
      direction: 'vertical',
      spaceBetween: 20,
      slidesPerView: 5,
      watchOverflow: true,
      watchSlidesProgress: true,
      breakpoints: {
        // when window width is >= 320px
        320: {

        },
        // when window width is >= 1025px
        1025: {

        }
      }
    });

    const mainSlider = new Swiper(this.mainSlider, {
      wrapperClass: 'pdp__images-main-track',
      slideClass: 'pdp__gallery-image-zoom',
      speed: 500,
      spaceBetween: 10,
      loop: true,
      //preventClicks: false,
      //touchRatio: 0,
      //allowTouchMove:false,
      navigation: {
        nextEl: "#pdp__images .swiper-button-next",
        prevEl: "#pdp__images .swiper-button-prev",
      },
      thumbs: {
        swiper: thumbSlider,
      },
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        499: {
          slidesPerView: 'auto'
        },
        1025: {
          slidesPerView: 1,
        }
      }
    });

    const thumbSlider2 = new Swiper(this.thumbSlider2, {
      wrapperClass: 'pdp__images-thumbs-track',
      slideClass: 'pdp__image-thumb',
      centeredSlides: true,
      centeredSlidesBounds: true,
      direction: 'vertical',
      spaceBetween: 20,
      slidesPerView: 5,
      watchOverflow: true,
      watchSlidesProgress: true,
      breakpoints: {
        // when window width is >= 320px
        320: {

        },
        // when window width is >= 1025px
        1025: {

        }
      }
    });

    const mainSlider2 = new Swiper(this.mainSlider2, {
      wrapperClass: 'pdp__images-main-track',
      slideClass: 'pdp__image',
      speed: 500,
      spaceBetween: 10,
      navigation: {
        nextEl: "#pdp__images-model2 .swiper-button-next",
        prevEl: "#pdp__images-model2 .swiper-button-prev",
      },
      thumbs: {
        swiper: thumbSlider2,
      },
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        499: {
          slidesPerView: 'auto'
        },
        1025: {
          slidesPerView: 1,
        }
      }
    });

    if (document.querySelector('#change-model')) {
      document.querySelector('#change-model').addEventListener('change', function(){
        let value = this.value;
        if (value == 'first-model') {
          document.querySelector('#pdp__images-model2').classList.remove('pdp__images--active');
          document.querySelector('#pdp__images').classList.add('pdp__images--active');
          thumbSlider.update();
          mainSlider.update();
        }
        if (value == 'second-model') {
          document.querySelector('#pdp__images').classList.remove('pdp__images--active');
          document.querySelector('#pdp__images-model2').classList.add('pdp__images--active');
          thumbSlider2.update();
          mainSlider2.update();
        }
      });
    }

//Gallery PDP - image zoom
  $(window).bind("resize load", function () {
    var wW = $(this).width();
    var limit = 1024;

    //on hover desktop
    if (wW >= limit ) {
    $('a.mobile-zoom').click(false);
    $(".pdp__gallery-image-zoom").mouseenter(function(e){
      e.preventDefault();
      $('.pdp__gallery-image-zoom').mousemove(function(e){      
        zoom(e);
       $(this).find('img').css('opacity', '0');
      });
    });

    $(".pdp__gallery-image-zoom").mouseleave(function(e){
       $(this).find('img').css('opacity', '1');
       $(".pdp__gallery-image-zoom").unbind('mousemove');
    });
    }else{
      $(".pdp__gallery-image-zoom").unbind('mousemove');
      // on click for mobile
      $('a.mobile-zoom').magnifik();
    }
  }).trigger('resize');
  
  function zoom(e){
      var x, y, offsetX, offsetY;
      var zoomer = e.currentTarget;
      if(e.offsetX) {
          offsetX = e.offsetX;
      } else {
          offsetX = e.touches[0].pageX;
      }

      if(e.offsetY) {
          offsetY = e.offsetY;
      } else {
          offsetX = e.touches[0].pageX;
      }
      x = offsetX/zoomer.offsetWidth*100;
      y = offsetY/zoomer.offsetHeight*100;

      zoomer.style.backgroundPosition = x+'% '+y+'%';
  }



    //Sticky add to cart 
    document.querySelector('#btn-atc').addEventListener('click', function(){
      this.classList.add('remove');

      document.querySelector('.sticky-form').classList.add('sticky-form--active');
    });

    document.querySelector('.js-sticky-form-close').addEventListener('click', function(){
      document.querySelector('#btn-atc').classList.remove('remove');

      document.querySelector('.sticky-form').classList.remove('sticky-form--active');
    });

    window.addEventListener('scroll', function() {
      var element = document.querySelector('#pdp__bottom');
      var position = element.getBoundingClientRect();
    
      // checking for partial visibility
      if(position.top < window.innerHeight && position.bottom >= 0) {
        document.querySelector('#btn-atc').classList.add('remove');
      }else{
        document.querySelector('#btn-atc').classList.remove('remove');
      }
    });

  }

  Behaviors.inherit(PDSlider, Behaviors.Behavior);
  PDSlider.QUERY = '.pdp__container';

  Behaviors.register_behavior(PDSlider);
  
  return PDSlider;

  }(window.jQuery, window.Behaviors));